import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Button, FormLabel, Grid, Text, Typography } from '@tq/ui-components';

import { NumberBox } from 'components';
import { ConsultationResponseAnswer } from 'types';
import { FaChevronRight } from 'react-icons/fa';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

type RpcOtherResponseProps = {
  answer: ConsultationResponseAnswer;
};

export const RpcOtherResponseAnswers: React.FC<RpcOtherResponseProps> = ({ answer }) => {
  const { t } = useTranslation('consultation_response');
  const [showAnswer, setShowAnswer] = useState(false);
  const handleShowAnswer = () => {
    setShowAnswer(!showAnswer);
  };
  const formatLocaleDate = useFormatLocaleDate();

  return (
    <>
      <Box
        backgroundColor={COLOURS.gray[200]}
        borderBottom={`1px solid ${COLOURS.gray[400]}`}
        borderBottomRadius={0}
        borderRadius={5}
        p={4}
      >
        <Box display='inline' mr={4}>
          <strong>{t('question_text', 'Question')}</strong>
        </Box>
        <NumberBox label={answer.questionNumber} />
        <Grid templateColumns={{ base: '1fr', lg: '6fr 1fr' }}>
          <Typography py={2}>{answer.question}</Typography>
        </Grid>
      </Box>
      <Box backgroundColor={{ lg: COLOURS.gray[200] }} borderRadius={5} p={4} mb={4}>
        <Box display='inline' mr={4}>
          <Button
            float='right'
            display={{ base: 'block', lg: 'none' }}
            size='xs'
            top={6}
            variant='tertiary'
            px={0}
            rightIcon={<FaChevronRight style={{ display: 'inline' }} />}
            onClick={handleShowAnswer}
          >
            {!showAnswer && t('show_answer', 'Show answer')}
            {showAnswer && t('hide_answer', 'Hide answer')}
          </Button>
        </Box>
        <Grid templateColumns={{ base: '1fr', lg: '6fr 1fr' }}>
          <Box mb={4} backgroundColor={{ lg: COLOURS.gray[200] }} borderRadius={5}>
            <Text display={'inline-block'} mr={11}>
              <FormLabel float='left' pr={1}>
                {t('responded_text', 'Responded')}:
              </FormLabel>
              {formatLocaleDate(answer.dateCreated)}
            </Text>
            <Text display={'inline-block'}>
              <FormLabel float='left' pr={1}>
                {t('by_text', 'By')}:
              </FormLabel>
              {answer.consulteeName}
            </Text>
          </Box>
          <Button
            display={{ base: 'none', lg: 'block' }}
            size='xs'
            variant='tertiary'
            onClick={handleShowAnswer}
          >
            {!showAnswer && t('show_answer', 'Show answer')}
            {showAnswer && t('hide_answer', 'Hide answer')}
          </Button>
        </Grid>
      </Box>
      {showAnswer && (
        <>
          <Box px={2} mb={8}>
            <strong>{t('answer', 'Answer')}</strong>
            <Typography pt={2}>{answer.answer}</Typography>
          </Box>
        </>
      )}
    </>
  );
};
